import { render } from "./JsonEditorItem.vue?vue&type=template&id=3ad5ff56"
import script from "./JsonEditorItem.vue?vue&type=script&lang=js"
export * from "./JsonEditorItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__